import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "chipsContainer", "errorMessage"]

  static values = {
    url: String,
    parseErrorMessage: String,
    debounceMs: { type: Number, default: 1000 }
  }

  connect() {
    this.requestSeq = 0
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  textareaInput() {
    this.hideError()
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.parse(), this.debounceMsValue)
  }

  async parse() {
    const text = this.textareaTarget.value
    const seq = ++this.requestSeq

    if (text.trim().length === 0) {
      if (seq === this.requestSeq) this.chipsContainerTarget.innerHTML = ""
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Accept": "text/html",
          "X-CSRF-Token": this.csrfToken()
        },
        body: new URLSearchParams({ text }).toString()
      })

      if (seq !== this.requestSeq) return

      if (!response.ok) {
        this.showError(this.parseErrorMessageValue)
        return
      }

      const html = await response.text()
      if (seq !== this.requestSeq) return

      this.chipsContainerTarget.innerHTML = html
    } catch (_e) {
      if (seq === this.requestSeq) this.showError(this.parseErrorMessageValue)
    }
  }

  removeChip(event) {
    const chip = event.currentTarget.closest("[data-component-chip]")
    if (chip) chip.remove()
  }

  showError(message) {
    if (!this.hasErrorMessageTarget) return
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorMessageTarget) return
    this.errorMessageTarget.classList.add("hidden")
    this.errorMessageTarget.textContent = ""
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
